import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DepartmentViewModel } from '@app/_models/_viewModels/department.viewmodel';
import { UploadFile, NzMessageService } from 'ng-zorro-antd';
import { Media } from '@app/_models/_DTOs/media';
import { environment } from '@environments/environment';
import { NgForm } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { Department } from '@app/_models/_DTOs/department';
import { ResizeService } from '@app/_services/resize.service';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AutonumericOptions } from '@angularfy/autonumeric/lib/autonumeric.model';
import { ZXingScannerComponent } from '@zxing/ngx-scanner';
import { DepartmentService } from '@app/_services/department.service';
import { LegalEntity } from '@app/_models/_DTOs/legalEntity';
import { LegalEntityService } from '@app/_services/legalEntity.service';

@Component({
  selector: "app-department-editor",
  templateUrl: "./department-editor.component.html",
  styleUrls: ["./department-editor.component.css"],
})
export class DepartmentEditorComponent implements OnInit {
  @Input() hiddenFields: string[];
  @Input() disabledFields: string[];
  @Input() departmentViewModel: DepartmentViewModel;
  @Input() isEditing: boolean;
  @Output() doneEditing = new EventEmitter<number>();

  public createForm: NgForm;

  drawerWidth: string;

  isSavingDepartment: boolean = false;
  loadingDropdowns: boolean = false;

  errorMessages = {};

  apiUrl: string;

  private delayTimer;

  legalEntities: LegalEntity[] = [];

  constructor(
    private departmentService: DepartmentService,
    private legalEntityService: LegalEntityService,
    private messageService: NzMessageService,
    private resizeService: ResizeService
  ) {
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe((size) => {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    });
  }

  ngOnInit() {
    if (this.resizeService.currentSize != null) {
      this.drawerWidth = this.resizeService.getDrawerWidth();
    }
    this.loadDataForDropdowns();
  }

  resetForm() {
    this.departmentViewModel = null;
  }

  finish(departmentId: number, form?: NgForm) {
    if (form) {
      form.reset();
    }
    this.departmentViewModel = null;
    this.doneEditing.emit(departmentId);
  }

  pad(num, size) {
    var s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  loadDataForDropdowns() {
    this.loadingDropdowns = true;
    this.legalEntityService.getAllBasic().subscribe((data: LegalEntity[]) => {
      this.legalEntities = data;
    });
  }

  saveDepartment(form: NgForm) {
    this.isSavingDepartment = true;
    if (this.isEditing) {
      this.departmentService
        .put(this.departmentViewModel, this.departmentViewModel.id)
        .subscribe(
          (result) => {
            this.messageService.create(
              "success",
              "Radna jedinica uspješno izmijenjena",
              {
                nzDuration: 3000,
              }
            );
            this.isSavingDepartment = false;
            this.finish(this.departmentViewModel.id, form);
          },
          (error) => {
            if (error.ParamName) {
              if (form.controls[error.ParamName]) {
                form.controls[error.ParamName].setErrors({ custom: true });
                var errorMessage = error.Message.split("Parameter name")[0];
                this.errorMessages[error.ParamName] = errorMessage;
              }
            }
            this.isSavingDepartment = false;
          }
        );
    } else {
      this.departmentService
        .post<DepartmentViewModel>(this.departmentViewModel)
        .subscribe(
          (result) => {
            this.messageService.create(
              "success",
              "Radna jedinica uspješno dodana"
            );
            this.isSavingDepartment = false;
            this.finish(result as number, form);
          },
          (error) => {
            if (error.ParamName) {
              if (form.controls[error.ParamName]) {
                form.controls[error.ParamName].setErrors({ custom: true });
                var errorMessage = error.Message.split("Parameter name")[0];
                this.errorMessages[error.ParamName] = errorMessage;
              }
            }
            this.isSavingDepartment = false;
          }
        );
    }
  }

  isFieldHidden(fieldName: string) {
    if (this.hiddenFields) {
      if (this.hiddenFields.length > 0) {
        if (this.hiddenFields.some((x) => x == fieldName)) {
          return false;
        }
      }
    }
    return true;
  }

  isFieldEnabled(fieldName: string) {
    if (this.disabledFields) {
      if (this.disabledFields.length > 0) {
        if (this.disabledFields.some((x) => x == fieldName)) {
          return false;
        }
      }
    }
    return true;
  }
}
